const simplePrintDialog = () => {
    if (typeof window === "undefined") {
        return;
    }

    window.print();
};

export default simplePrintDialog;
